import request from '@/utils/request'
import FormData from 'form-data'
// import axios from 'axios'

// const CancelToken = axios.CancelToken

export function createQuestionWithAI(data, handleProgress, cancel) {
  const upload = new FormData()
  upload.append('file', data.file)
  upload.append('idHomework', data.idHomework)

  if (data.questionTypes && data.questionTypes.length) {
    data.questionTypes.forEach((type, index) => {
      upload.append(`questionTypes[${index}]`, type)
    })
  }

  upload.append('hasAnswerHint', data.hasAnswerHint)

  return request({
    url: `/homework/es-homework/ai-flow`,
    method: 'post',
    timeout: false,
    data: upload,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: handleProgress
    // cancelToken: new CancelToken(function executor(c) {
    //   cancel(c)
    // })
  })
}

export function createQuestionExamVaultWithAI(data, handleProgress, cancel) {
  const upload = new FormData()
  upload.append('file', data.file)
  upload.append('idHomework', data.idHomework)

  if (data.questionTypes && data.questionTypes.length) {
    data.questionTypes.forEach((type, index) => {
      upload.append(`questionTypes[${index}]`, type)
    })
  }

  upload.append('hasAnswerHint', data.hasAnswerHint)

  return request({
    url: `/exam-vault/homeworks/ai-flow`,
    method: 'post',
    timeout: false,
    data: upload,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: handleProgress
    // cancelToken: new CancelToken(function executor(c) {
    //   cancel(c)
    // })
  })
}
